import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Sidebar",
  inserter: false,
  icon: "align-right",
}

export default defineBlock("film/film-sidebar", (props) => {
  return (
    <div>
      <InnerBlocks
        defaultBlocks={[
          ["film/film-sponsors", {}],
          ["film/film-credits", {}],
        ]}
        allowedBlocks={["film-sidebar"]}
        adminClassName="flex flex-col gap-4"
        appender={{
          type: "simple",
        }}
      />
    </div>
  )
})
